import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { PlanTierService } from "../../plan-tier/plan-tier.service";
import { RememberService } from "../../remember/remember.service";
import { UpgradeModalService } from "../../upgrade-modal/upgrade-modal.service";
import { HotspotIdentifiers } from "./hotspot-identifiers";

interface IHotspotType {
  dataFormat: string;
  description: string;
  identifier: string;
  label: string;
}

@Component({
  selector: "ab-project-hotspots",
  templateUrl: "./hotspots.component.html",
})
export class HotspotsComponent implements OnInit {
  @Input() public project: any;
  @Input() public dur: string;
  @Input() public lastN: number;

  public featureDisabled: boolean;
  public selectedHotspotType: IHotspotType;
  public hotspotTypes = [
    {
      dataFormat: "attribute",
      description: "Files with the most errors",
      identifier: "errors.0.file",
      label: "Files",
    },
    {
      dataFormat: "attribute",
      description: "Most common messages by number of errors",
      identifier: "errors.0.message",
      label: "Error messages",
    },
    {
      dataFormat: "attribute",
      description: "URLs with the most errors",
      identifier: "context.url",
      label: "URLs",
    },
    {
      dataFormat: "diffStat",
      description: "Most changed files",
      identifier: HotspotIdentifiers.DIFF_STATS.changed,
      label: "Changed files",
    },
    {
      dataFormat: "diffStat",
      description: "Most frequently modified files",
      identifier: HotspotIdentifiers.DIFF_STATS.touched,
      label: "Touched files",
    },
    {
      dataFormat: "attribute",
      description: "Users who saw errors",
      identifier: "context.user",
      label: "Users",
    },
  ] as IHotspotType[];

  private rememberKey = "hotspots.selectedType";

  constructor(
    private planTierService: PlanTierService,
    private rememberService: RememberService,
    private upgradeModal: UpgradeModalService,
  ) {}

  public ngOnInit() {
    this.planTierService.features().subscribe(
      (features: any) => {
        this.featureDisabled = !features.hotspots;

        if (!this.featureDisabled) {
          const defaultIdentifier = "errors.0.file";
          const identifier = this.rememberService.get(
            this.rememberKey,
            defaultIdentifier,
          );
          for (const hotspotType of this.hotspotTypes) {
            if (hotspotType.identifier === identifier) {
              this.selectedHotspotType = hotspotType;
              break;
            }
          }
        } else {
          this.selectedHotspotType = this.hotspotTypes[1];
        }
      },
      (_response: HttpErrorResponse) => {
        // Results in an empty "Hotspots" section on the dashboard. This could
        // be improved with an empty state and a button to retry fetching the
        // data.
        return;
      },
    );
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public selectHotspotType(hotspotType: IHotspotType) {
    if (this.featureDisabled !== false) {
      return;
    }

    this.selectedHotspotType = hotspotType;
    this.rememberService.set(this.rememberKey, hotspotType.identifier);
  }

  public openUpgradeModal($event: Event) {
    this.upgradeModal.open($event);
  }
}
